// extracted by mini-css-extract-plugin
module.exports = {"followMe":"lI","linkItem":"lJ","linkItemWrap":"lK","title":"lL","linkAppItemWrap":"lM","iconWrap":"lN","mfollowMe":"lO","miconWrap":"lP","followMe-dark":"lQ","followMeDark":"lQ"};